import type { SyntheticEvent } from 'react';

/**
 * توحيد بروتوكول الرابط فقط (// → https، وترقية http على cdn.otlob.io).
 * لا يُبدّل النطاق — صور المنتجات قد تبقى على cdn.teen-sa.com حتى تُنقل بالكامل.
 */
export function normalizeMediaUrl(url: string | undefined | null): string {
  if (!url || typeof url !== 'string') return '';
  let u = url.trim();
  if (!u) return '';

  if (u.startsWith('//')) {
    u = `https:${u}`;
  }

  if (
    u.startsWith('http://') &&
    /cdn\.otlob\.io/i.test(u)
  ) {
    u = `https://${u.slice('http://'.length)}`;
  }

  return u;
}

/**
 * شعار/بنر المتجر: نفس normalizeMediaUrl فقط.
 * لا نستبدل cdn.teen-sa.com بـ otlob — المحتوى على R2 غالباً على teen-sa فقط ونسخة otlob قد تعيد 404.
 */
export function normalizeStoreAssetUrl(url: string | undefined | null): string {
  return normalizeMediaUrl(url);
}

/** بعد فشل التحميل: إصلاح البروتوكول، ثم تجربة teen-sa إن كان الرابط على otlob (المزامنة غير كاملة) */
export function onCdnImageError(e: SyntheticEvent<HTMLImageElement>): void {
  const img = e.currentTarget;
  if (img.dataset.retried) return;
  img.dataset.retried = '1';
  const raw = img.getAttribute('src') || '';
  const fixed = normalizeMediaUrl(raw);
  if (fixed && fixed !== img.src) {
    img.src = fixed;
    return;
  }
  if (/cdn\.otlob\.io/i.test(img.src)) {
    img.src = img.src.replace(/cdn\.otlob\.io/gi, 'cdn.teen-sa.com');
  }
}
